<!--
 * @Description: 查看用户协议配置
 * @Author: 钱磊
 * @Date: 2022-08-26 14:43:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-26 14:48:59
-->

<!--  -->
<template>
  <div class="h100 mt20">
    <el-form
      ref="checked"
      :model="checkForm"
      label-width="100px"
      size="small"
      :show-message="false"
    >
      <el-row class="mt-20">
        <el-col :span="8">
          <el-form-item label="应用场景：">
            {{ checkForm.sceneApplyName }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="场景ID：">
            {{ checkForm.sceneId }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="创建人：">
            {{ checkForm.createUser }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="创建时间：">
            {{ checkForm.createDate }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="状态：">
            {{ checkForm.status?'已开启':'已关闭' }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <h5 class="mt20">
      关联的协议：
    </h5>
    <div class="w-table-content" >
      <vxe-table
        :data="choiseTable.tableData"
        :loading="choiseTable.loading"
        :border="choiseTable.border"
        :resizable="choiseTable.resizable"
        :size="choiseTable.size"
        show-overflow="tooltip"
        show-header-overflow="tooltip"
      >
        <vxe-table-column
          type="seq"
          title="序号"
          align="center"
          width="70"
        ></vxe-table-column>
        <vxe-table-column
          field="sname"
          title="协议名称"
          align="center"
          show-overflow-tooltip
        ></vxe-table-column>
        <vxe-table-column
          field="remark"
          title="备注"
          align="center"
          show-overflow-tooltip
        ></vxe-table-column>
        <vxe-table-column
          field="version"
          title="当前版本"
          align="center"
          show-overflow-tooltip
        ></vxe-table-column>
      </vxe-table>
    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";
import * as API from "api/modules/rulesManagement";
export default {
  data() {
    return {
      checkForm: {}, //协议配置信息详情
      configs: [], //未配置业务场景
      sceneApplys: [], //已配置业务场景
      choiseTable: {
        //已选中协议列表对象
        tableData: [], //
        loading: false,
        border: true,
        resizable: true,
        size: "small",
        height: "100%",
      },
    };
  },
  components: {},
  mounted() {
    if (this.$getSessionItem("agreementInfo")) {
      this.checkForm = JSON.parse(this.$getSessionItem("agreementInfo"));
    }
    this.getConfig();
    console.log(this.checkForm)
  },
  methods: {
    // 协议配置-明细查询
    getConfig() {
      let param = {
        id: this.checkForm.id,
      };
      API.getConfig(param).then((res) => {
        this.choiseTable.tableData = res.data.dealList;
      });
    },
  },
  computed: {
    routeQuery() {
      return this.$route.query.type;
    },
  },

};
</script>
<style scoped lang='less'>
h5,
h6,
p {
  padding-bottom: 10px;
  border-bottom: 1px solid #333;
}
p {
  font-size: 12px;
}
/deep/ .el-radio-button {
  width: 200px !important;
  margin-left: 20px;
}
/deep/ .el-radio-group {
  display: flex;
  flex-wrap: wrap;
}
/deep/ .el-radio-button__inner {
  border: 1px solid #dcdfe6 !important;
  margin: 10px !important;
  width: 100%;
  display: inline-block;
  border-radius: 4px !important;
}
.check_group {
  width: 100%;
  padding: 20px;
  background-color: #f2f2f2;
  span {
    display: inline-block;
    margin-left: 10px;
    padding: 10px 20px;
    background-color: #fff;
    border: 1px solid #ddd;
    .el-icon-circle-close {
      margin-left: 10px;
      cursor: pointer;
    }
  }
}
.w-table-content {
  width: 70%;
  margin: 20px 0 0 20px;
}
</style>